import { useState, useMemo } from "react";
import { Formik } from "formik";
import CMSSlider from "../formFields/CMSSlider";
import CMSFormRadioButtons from "../formFields/CMSFormRadioButtons";
import CMSFormCheckBoxes from "../formFields/CMSFormCheckBoxes";
import CMSFormCheckBox from "../formFields/CMSFormCheckBox";
import { formatString } from "../utils/commonHelper";

const Filters = ({ content, selectedFilters, onApplyFilters }) => {
  function formatArray(array) {
    return array.map((item) => ({
      label: formatString(item.value),
      value: item.normalizedValue,
    }));
  }
  const [openIndexes, setOpenIndexes] = useState([]);

  const AccordionItem = ({ title, children, isOpen, onToggle }) => (
    <div className="rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={onToggle}
        title={isOpen ? "Click to hide options" : "Click to view options"}
        className="w-full text-left px-4 py-2 bg-gray-100 hover:bg-gray-200 flex justify-between items-center text-secondary hover:text-quaternary"
      >
        <span>{title}</span>
        <span>{isOpen ? "−" : "+"}</span>
      </button>
      <div
        className={`px-4 pt-2 pb-0 transition-all duration-300 overflow-hidden ${
          isOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        {children}
      </div>
    </div>
  );

  const toggleIndex = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        category: selectedFilters.categories,
        materials: selectedFilters.materials,
        priceRange: "",
        discounted: selectedFilters.discounted === "1" ? "1" : "0",
        inStock: selectedFilters.inStock === "1" ? "1" : "0",
      }}
      onSubmit={(values) => {
        //console.log(values);
        const payload = {
          category: values.category,
          materials: values.materials,
          priceRange: values.priceRange,
          discounted: values.discounted === "1" ? "1" : "0",
          inStock: values.inStock === "1" ? "1" : "0",
        };
        onApplyFilters(payload);
      }}
    >
      {(form) => {
        const accordionItems = [
          {
            title: "Choose a Category",
            content: (
              <CMSFormCheckBoxes
                name="category"
                form={form}
                options={formatArray(content.categories)}
              />
            ),
          },
          {
            title: "Choose Materials",
            content: (
              <CMSFormCheckBoxes
                name="materials"
                form={form}
                options={formatArray(content.materials)}
              />
            ),
          },
          {
            title: `Price (between)`,
            content: (
              <CMSSlider
                name="priceRange"
                form={form}
                priceRange={content.priceRange}
                value={form.values.price}
                onChange={(val) => form.setFieldValue("priceRange", val)}
              />
            ),
          },
          {
            title: "More Filters",
            content: (
              <>
                <CMSFormCheckBox
                  name="discounted"
                  form={form}
                  className="small"
                  label="Discounted"
                />
                <CMSFormCheckBox
                  name="inStock"
                  form={form}
                  label="In Stock"
                  className="small"
                />
              </>
            ),
          },
        ];

        return (
          <>
          
            <div className="space-y-3">
              {accordionItems.map((item, index) => (
                <AccordionItem
                  key={index}
                  title={item.title}
                  isOpen={openIndexes.includes(index)}
                  onToggle={() => toggleIndex(index)}
                >
                  {item.content}
                </AccordionItem>
              ))}
            </div>

            <div className="mt-4 flex justify-between flex-wrap gap-3">
              <button
                type="button"
                title="Click to reset filters"
                className="px-4 py-2 bg-gray-300 text-orange rounded hover:text-orange/70"
                onClick={() => {
                  form.handleReset();
                  if (onApplyFilters) onApplyFilters({});
                }}
              >
                Reset All Filters
              </button>
              <button
                type="button"
                title="Click to apply filters"
                className="px-4 py-2 bg-green-600 text-green rounded hover:text-green/70"
                onClick={form.handleSubmit}
              >
                Apply
              </button>
            </div>
          </>
        );
      }}
    </Formik>
  );
};

export default Filters;
